import { render, staticRenderFns } from "./addFileDialog.vue?vue&type=template&id=6dc7263c&scoped=true"
import script from "./addFileDialog.vue?vue&type=script&lang=js"
export * from "./addFileDialog.vue?vue&type=script&lang=js"
import style0 from "./addFileDialog.vue?vue&type=style&index=0&id=6dc7263c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc7263c",
  null
  
)

export default component.exports